//@ts-check
import debug from "debug";
import { MediumRow } from "./MediumRow";
import { UsageSelector } from "./UsageSelector";

export const log = debug("licensing-selector");

/** Event name for when any of the licensing selections change (medium, options, client name) */
export const LICENSING_SELECTION_CHANGE = "licensing-selection-change";

/**
 * The area where users can select Desktop, Web, Branding, etc.
 *
 * HTML: Licensing::LicensingSectionComponent
 *
 * Children:
 * - MediumRow (-> OptionSelector)
 * - UsageSelector
 *
 * Parent:
 * - PurchasingSectionComponent
 *
 * Siblings:
 * - FontsSelector
 */
export class LicensingSelector {
  /** @type {{[slug: string]: MediumRow}} */
  mediums;

  constructor(element) {
    this.log = log.extend(`LicensingSelector`);
    this.log("Creating LicensingSelector", element);

    this.element = element;
    this.mediums = Array.from(
      this.element.querySelectorAll(".licensing-medium-row")
    ).reduce((acc, element) => {
      const mediumRow = MediumRow.fromElement(element);
      acc[mediumRow.slug] = mediumRow;
      return acc;
    }, {});

    // For Branding
    this.usageSelector = new UsageSelector(this.element);
  }

  disconnect() {
    Object.values(this.mediums).forEach((mediumRow) => {
      mediumRow.disconnect();
    });
    this.usageSelector.disconnect();
  }
}
